import Extensions from "./Extensions";
export default Extensions;
